import graphql__b36cbf024d05b6b511d3 from "./__generated__/UsersMapDetailsManagerQuery.graphql.js";import { graphql } from "react-relay";

import UsersMapDetails from "./UsersMapDetails";
import AppQueryRenderer from "../../AppQueryRenderer";
import MapPanelSpinner from "../MapPanel/MapPanelSpinner";
import { USERS_MAP_USERS_COUNT } from "../../Routes/UsersMapRoute";
import { useMapContext } from "../MapContext";

const UsersMapDetailsManager = props => {
  const { mapSlug: usersMapSlug } = useMapContext();
  const usersMapUsersCount = USERS_MAP_USERS_COUNT;

  return (
    <AppQueryRenderer
      key={usersMapSlug}
      query={UsersMapDetailsManagerQuery}
      variables={{ usersMapSlug, usersMapUsersCount }}
      component={UsersMapDetails}
      additionalProps={props}
      loader={<MapPanelSpinner />}
    />
  );
};

const UsersMapDetailsManagerQuery = graphql__b36cbf024d05b6b511d3;

export default UsersMapDetailsManager;
